"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueriesRegistry = void 0;
const ramda_1 = require("ramda");
const events_1 = require("./events");
class Registry {
    constructor() {
        this.handleQueryChange = ({ query, type }) => {
            // TODO - is it the only type that we should listen?
            // Hypotesis is, that add/remove of the query should not affect the listener instances, as they
            // care only about the data
            if (type === 'updated') {
                this.trackedQueries.forEach(({ queryKey }, queryHash) => {
                    if ((0, ramda_1.startsWith)(queryKey, query.queryKey)) {
                        (0, events_1.shareQuery)({ queryHash, queryKey, queryState: query.state });
                    }
                });
            }
        };
        this.subscribeToCache = (queryCache) => {
            if (!this.queryClientCacheSubscription) {
                this.queryClientCacheSubscription = queryCache.subscribe(this.handleQueryChange);
            }
        };
        this.trackQuery = (queryKey, queryKeyHash) => {
            if (!this.trackedQueries.has(queryKeyHash)) {
                this.trackedQueries.set(queryKeyHash, { queryKey, subscribedInstances: 1 });
            }
            else {
                const { subscribedInstances } = this.trackedQueries.get(queryKeyHash);
                this.trackedQueries.set(queryKeyHash, {
                    queryKey,
                    subscribedInstances: (0, ramda_1.inc)(subscribedInstances)
                });
            }
        };
        this.subscribe = (queryCache, queryKey) => {
            this.subscribeToCache(queryCache);
            const queryKeyHash = queryKey.join('');
            this.trackQuery(queryKey, queryKeyHash);
            return this.unsubscribeInstance(queryKeyHash);
        };
        this.unsubscribeInstance = (queryKeyHash) => () => {
            const trackedQuery = this.trackedQueries.get(queryKeyHash);
            if (trackedQuery) {
                const { subscribedInstances } = trackedQuery;
                const updatedSubscribedInstances = (0, ramda_1.dec)(subscribedInstances);
                this.trackedQueries.set(queryKeyHash, Object.assign(Object.assign({}, trackedQuery), { subscribedInstances: updatedSubscribedInstances }));
                if (updatedSubscribedInstances <= 0) {
                    this.trackedQueries.delete(queryKeyHash);
                    (0, events_1.deleteSharedQuery)({ queryHash: queryKeyHash });
                }
            }
        };
        this.queryClientCacheSubscription = null;
        this.trackedQueries = new Map();
    }
}
const QueriesRegistry = new Registry();
exports.QueriesRegistry = QueriesRegistry;
